import React from "react";
import Slider from "react-slick";
import { BaseUrl } from "../../helper/BaseUrl";

export default function DynamicFeatures({ data, extraClass = "" }) {

    const settingskey = {
        autoplay: true,
        speed: 5000,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: false,
        dots: true,
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                },
            },

            {
                breakpoint: 99999,
                settings: "unslick",
            },
        ],
    };
    const items = [
        {
            icon: data?.section3_point1_icon,
            heading: data?.section3_point1_heading,
            description: data?.section3_point1_description,
        },
        {
            icon: data?.section3_point2_icon,
            heading: data?.section3_point2_heading,
            description: data?.section3_point2_description,
        },
        {
            icon: data?.section3_point3_icon,
            heading: data?.section3_point3_heading,
            description: data?.section3_point3_description,
        },
        {
            icon: data?.section3_point4_icon,
            heading: data?.section3_point4_heading,
            description: data?.section3_point4_description,
        },
        {
            icon: data?.section3_point5_icon,
            heading: data?.section3_point5_heading,
            description: data?.section3_point5_description,
        },
        {
            icon: data?.section3_point6_icon,
            heading: data?.section3_point6_heading,
            description: data?.section3_point6_description,
        }
    ]

    if (!data) return null;


    return (
        <section className={`healthcare-facility ${extraClass}`}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12 col-lg-8">
                        <div className="facility-text center-heading">
                            <h3 className="heading" dangerouslySetInnerHTML={{ __html: data?.section3_heading }} />
                        </div>
                    </div>
                </div>
                <Slider {...settingskey} className="key-slides">
                    {items.map((item, index) => (
                        <div className="facility-slide" key={index}>
                            <div className="facility-col">
                                <div className="icon">
                                    <img src={item?.icon ? `${BaseUrl}${item.icon}` : undefined} className="img-responsive" alt={item?.heading} />
                                </div>
                                <div className="heading">{item?.heading}</div>
                                <p>{item?.description}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    )
}



